module.exports = __webpack_public_path__ + "7bfff648fbc1be38777c90df798ade7a.jpg";